<div class="rd-widget" *ngIf="(widgetData$ | async) as widgetData">
  <h3>VALUATION UNIT</h3>
    <table class="widget-header-title" aria-hidden="true">
        <tbody>
          <tr>
            <td colspan="3" class="widget-column-title" style="vertical-align: top;"> &nbsp;</td>
            <td colspan="8" class="widget-column-value ">
              &nbsp;
            </td>
          </tr>
          <tr *ngIf="widgetData.propertyName">
            <td colspan="3" class="widget-column-title" style="vertical-align: top;">{{'widgets.propertyValuationUnit.propertyName' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.propertyName }}
            </td>
          </tr>
          <tr *ngIf="widgetData.street">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.street' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{widgetData.street}}
            </td>
          </tr>
          <tr *ngIf="widgetData.no">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.no' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{widgetData.no}}
            </td>
          </tr>
          <tr *ngIf="widgetData.postCode">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.postCode' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.postCode }}
            </td>
          </tr>
          <tr *ngIf="widgetData.city">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.city' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.city }}
            </td>
          </tr>
          <tr *ngIf="widgetData.country">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.country' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.country }}
            </td>
          </tr>
          <tr>
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.propertyArea' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.propertyArea | number:'1.0-2'}} {{unitOfLength}}²
            </td>
          </tr>
          <tr>
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.numberOfUnits' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.numberOfUnits }}
            </td>
          </tr>

          <tr *ngIf="widgetData.tenure">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.tenture' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.tenure }}
            </td>
          </tr>
          <tr *ngIf="widgetData.propertyId">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.propertyId' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.propertyId }}
            </td>
          </tr>
          <tr *ngIf="widgetData.valuationDate">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.valuationDate' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.valuationDate | rdLocalizedDate}}
            </td>
          </tr>
          <tr *ngIf="widgetData.status">
            <td colspan="3" class="widget-column-title">{{'widgets.propertyValuationUnit.status' | translate }}</td>
            <td colspan="8" class="widget-column-value ">
              {{ widgetData.status }}
            </td>
          </tr>
        </tbody>
    </table>
</div>
